<template>
  <nav :class="['header-nav__mobile',{'open': isOpen}]">
    <div :class="['nav-icon',{'open': isOpen}]" @click="isOpen = !isOpen">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'HamburgerMenu',

    data() {
      return {
        isOpen: false
      }
    },
  };
</script>
